module.exports = __webpack_public_path__ + "img/11_79.d9f9480e.png";